<template>
  <header class="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-md shadow-sm z-[1001] border-b border-blue-100">
    <div class="flex items-center max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
      <button
        @click="goBack"
        class="flex items-center justify-center h-9 w-9 rounded-full bg-blue-50 hover:bg-blue-100 text-blue-900 hover:text-yellow-500 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-900 focus:ring-offset-2 focus:ring-offset-white/90 mr-2"
        aria-label="Back"
      >
        <span class="material-symbols-outlined text-2xl">arrow_back</span>
      </button>
      <span class="text-blue-900 text-lg font-bold font-sans tracking-tight">{{ title }}</span>
    </div>
  </header>
  <div class="header-space h-16"></div>
</template>

<script>
export default {
  name: 'AppHeaderBack',
  props: {
    title: {
      type: String,
      default: 'Back'
    }
  },
  methods: {
    goBack() {
      const referrer = document.referrer;
      const isSameOrigin = referrer && referrer.startsWith(window.location.origin);
      if (window.history.length > 1 && isSameOrigin) {
        window.history.back();
      } else {
        this.$router.push('/');
      }
    }
  }
};
</script>

<style scoped>
header {
  height: 64px;
}
</style>
